<script lang="ts">
  import type { InputType } from '$src/types/forms';

  let {
    id,
    name,
    required,
    background,
    type,
    attributes,
    customValidation,
    placeholder,
    min,
    value = $bindable(''),
    onBlur,
    onFocus,
    onChange,
  }: InputType = $props();
</script>

<input
  {type}
  {id}
  {name}
  {required}
  {placeholder}
  {min}
  data-validate={customValidation}
  bind:value
  onwheel={(e) => {
    e.preventDefault();
  }}
  onfocus={onFocus}
  onblur={onBlur}
  onchange={onChange}
  {...attributes}
  data-background={background}
  class="2xl:fluid-text-[16] 2xl:fluid-h-[48] h-12 w-full border-b-1 border-[var(--border-color)] text-[var(--text-color)] focus:outline-offset-3"
/>
